export const breakpoints = {
    tablet: 600,
    desktop: 1300
};

export const random = (max, min = 1) => {
    return Math.floor(Math.random() * (max - min + 1) + min);
}
